import React from 'react'
import './SingleSlectSearch.css'
import Select from 'react-select'

const SingleSlectSearch = ({ placeholder, name, options, isSearchable, isClearable, isDisabled, defaultValue, value, onChange, styles, isOptionDisabled }) => {

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // background: '#fff',
            // borderColor: '#9e9e9e',
            minHeight: '35px',
            height: '35px',
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '35px',
            padding: '0 6px',
            // '&:hover': {cursor: 'pointer' },
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        // indicatorSeparator: state => ({
        //   display: 'block',
        // }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '35px',
        }),
        menuList: (provided, state) => ({
            ...provided,
            background: '#F7F7F7',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#545CD8' : 'inherit',
            cursor: state.isDisabled ? 'auto' : 'pointer',
            '&:hover': { backgroundColor: state.isSelected ? '#545CD8' : 'rgb(222, 235, 255)' }
        }),
        groupHeading: (provided, state) => ({
            ...provided,
            fontFamily: 'Helvetica',
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: 1.2,
            color: '#495057',
            textTransform: 'capitalize'
})
    };

    return (
        <Select
            className="singleSelectOpt"
            classNamePrefix="select"
            // defaultValue={defaultValue || 'Select'}
            placeholder={placeholder || 'Select'}
            name={name || false}
            options={options || []}
            isSearchable={isSearchable || false}
            isClearable={isClearable || false}
            isDisabled={isDisabled || false}
            value={value || null}
            onChange={onChange}
            isOptionDisabled={isOptionDisabled}
            styles={styles || customStyles}
        />
    )
}

export default SingleSlectSearch
